module.exports = "<div class=\"p-iframe\">\n  <iframe\n    src=\"https://app.powerbi.com/view?r=eyJrIjoiYmQ4ODNhNzMtMTBiMi00ZTA5LTlhNzYtMjhkNzNkMzFkOTUwIiwidCI6IjM5YTZhNjBlLTAwZTMtNGNiMy1hMmI0LWZhNmQ4ZDA1OTIwOCJ9\"\n  ></iframe>\n</div>\n\n<app-botao-flutuante-voltar [param]=\"param\"></app-botao-flutuante-voltar>\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/planos/plano/pbdc-dashboard/pbdc-dashboard.component.html
// module id = ../../../../../src/app/area-restrita/planos/plano/pbdc-dashboard/pbdc-dashboard.component.html
// module chunks = main